import { useMutation } from "@tanstack/react-query";
import { sendVacancyMessage } from "../api/vacancyApi";

// Envía un mensaje de consulta sobre una vacante.
export const useSendVacancyMessage = () =>
  useMutation({
    mutationFn: ({ vacancyId, message }: { vacancyId: string; message: string }) =>
      sendVacancyMessage(vacancyId, message),
  });
